import React from 'react'

import PropTypes from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

function TextareaField({
  label = '',
  id,
  value = '',
  onChange,
  onBlur = NOOP,
  formClassName = '',
  showError = false,
  errorText = null,
  rows = 3,
  autofocus = false,
  required = false,
  placeholder = '',
  name = '',
  disabled = false,
  inputClassName,
}) {
  const inputErrorClass = showError && errorText ? 'is-invalid' : ''

  return (
    <div className={`form-group ${formClassName}`}>
      {label.length > 0
        && (
        <label htmlFor={id}>
          {label}
          {required && <b> *</b>}
        </label>
        )
      }
      <textarea
        id={id}
        className={`form-control ${inputClassName} ${inputErrorClass}`}
        name={name}
        rows={rows}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        autoFocus={autofocus}
        placeholder={placeholder}
        disabled={disabled}
      />
      {showError
        && (
        <div className="error-message">
          <span className="text">{errorText}</span>
        </div>
        )
      }
    </div>
  )
}

TextareaField.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  formClassName: PropTypes.string,
  showError: PropTypes.bool,
  errorText: PropTypes.string,
  rows: PropTypes.number,
  autofocus: PropTypes.bool,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
}

export default TextareaField
